<div class="wrapper" style="overflow-x: hidden;"> 
    <div @enterTop class="page-header page-header-xs" data-parallax="true" style="background-image: url('./../../assets/imgs/projects-color.png');">
        <div class="filter"></div>
    </div>
    <div class="main">
        <div class="section text-center">
            <div class="container"> 
                <div class="row" style="justify-content: center;">
                    <div class="col-md-8">
                        <div class="info">
                            <div class="description">
                                <h4 class="info-title">{{ 'projects.product1.title' | translate }}</h4>                                
                                <p class="description">{{ 'projects.product1.description' | translate }}</p>
                                <div style="margin-top: 20px; justify-content: left;">
                                    <a style="margin-top: 20px;" href="https://easyweb.techview.es/home" target="_blank">{{ 'projects.product1.link' | translate }}</a>
                                </div>                                
                                <img style="width: 100%; margin-top: 15px;" src="../../../../assets/imgs/easyweb_screen.png" alt="Pantalla de ordenador con imagenes de EasyWeb">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="info">
                            <div class="description">
                                <h4 class="info-title">{{ 'projects.product2.title' | translate }}</h4>                                
                                <p class="description" style="white-space: pre-wrap;">{{ 'projects.product2.description' | translate }}</p>
                                <img style="width: 100%; margin-top: 15px;" src="../../../../assets/imgs/StockShare_screen.png" alt="Pantalla de ordenador con imagenes de StockShare">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    </div>
</div>